var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 10.0263V18.5C1.5 19.0523 1.94772 19.5 2.5 19.5H15.5C16.0523 19.5 16.5 19.0523 16.5 18.5V10.0263M1.5 10.0263V7.07895C1.5 6.52666 1.94772 6.07895 2.5 6.07895H5.84211M1.5 10.0263H16.5M16.5 10.0263V7.07895C16.5 6.52666 16.0523 6.07895 15.5 6.07895H12.1579M5.84211 4.5V6.07895M5.84211 6.07895V7.65789M5.84211 6.07895H12.1579M12.1579 4.5V6.07895M12.1579 6.07895V7.65789",
    stroke: "#424895",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.5L13 13.5",
    stroke: "#424895",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 16.5H13",
    stroke: "#424895",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.14118c27b565c2a9a3f97261695d2bcf.svg";
export { ForwardRef as ReactComponent };